import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextAreaInput, Button, useMobile } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { useValidations } from '../../../hooks/useValidations';

const TEXT_SIZE = 250;

const Submit: React.FC = () => {
  const { t } = useTranslation(TranslationsKeys.SURVEY);
  const { control, watch } = useFormContext();
  const comments = watch('comments');
  const isMobile = useMobile();

  return (
    <>
      <div
        className="h4 text-primary"
        style={{ fontWeight: 600, marginBottom: 16 }}
      >
        {t(`submit.title`)}
      </div>
      <div style={{ fontSize: '1.1rem', marginTop: -10, marginBottom: 20 }}>
        {t(`submit.description`)}
      </div>
      <TextAreaInput
        name="comments"
        label={t(`submit.textAreaLabel`)}
        control={control}
        className="mb-1"
        maxLength={TEXT_SIZE}
        rules={{
          validate: {
            maxLength: useValidations().validateMaxLength(TEXT_SIZE),
          },
        }}
      />
      <span>{`${comments?.length || 0}/${TEXT_SIZE}`}</span>

      <div className="text-right pb-5">
        <Button
          text={t(`submit.submitButton`)}
          type="submit"
          size={window.innerWidth < 768 ? 'md' : 'lg'}
          style={isMobile ? { width: '100%' } : { width: 300 }}
        />
      </div>
    </>
  );
};

export default Submit;
